import React, { useContext, useEffect, useState } from "react";
import "./USDT_Addresses.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Context } from "../../utils/context";
import { GetAllUSDTWallets, SetUSDTWallet } from "../../features/wallet/slice";
import { FaCheckCircle } from "react-icons/fa";

function USDT_Addresses() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { signin } = useContext(Context);

  const usdtWallets = useSelector((state) => state.wallet.usdtWallets);
  const selectedUSDTWallet = useSelector(
    (state) => state.wallet.selectedUSDTWallet,
  );

  const [selectedId, setSelectedId] = useState(() => {
    const saved = localStorage.getItem("selected_wallet_id");
    return saved ? Number(saved) : null;
  });

  useEffect(() => {
    if (signin) dispatch(GetAllUSDTWallets({}));
  }, [dispatch, signin]);

  useEffect(() => {
    if (usdtWallets?.length && selectedId && !selectedUSDTWallet) {
      const saved = usdtWallets.find((b) => b.id === selectedId);
      if (saved) dispatch(SetUSDTWallet(saved));
    }
    if (usdtWallets?.length === 0) {
      localStorage.removeItem("selected_wallet_id");
    }
  }, [usdtWallets, selectedId, selectedUSDTWallet, dispatch]);

  useEffect(() => {
    if (selectedUSDTWallet?.id) setSelectedId(selectedUSDTWallet.id);
  }, [selectedUSDTWallet]);

  const handleSelect = (bank) => {
    setSelectedId(bank);
    dispatch(SetUSDTWallet(bank));
    localStorage.setItem("selected_wallet_id", bank.id);
  };

  return (
    <section className="Bank_Account">
      <Common_white_header headingText={"USDT Addresses"} />

      <div className="container">
        {usdtWallets?.map((data) => (
          <div
            key={data.id}
            className={`bank-details-card ${
              selectedId === data.id ? "selected" : ""
            }`}
            onClick={() => handleSelect(data)}
            style={{ cursor: "pointer", position: "relative" }}
          >
            <div className="bank-row">
              <span className="label">Address</span>
              <span className="value">{data?.usdt_address || "N/A"}</span>
            </div>

            <hr></hr>
          </div>
        ))}

        {/* Confirm + Add Bank */}
        <div className="add-bank-section">
          {selectedId && usdtWallets?.length > 0 && (
            <button
              className="btn_register_bg mb-3"
              onClick={() => navigate(-1)}
            >
              Confirm Selection
            </button>
          )}
          <button
            className="btn_register_bg"
            onClick={() => navigate("/add-usdt-address")}
          >
            Add USDT Address
          </button>
        </div>
      </div>
    </section>
  );
}

export default USDT_Addresses;
